var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.357,
    height: 35.621,
    viewBox: "0 0 144.357 35.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14766",
    "data-name": "Group 14766",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14458",
    "data-name": "Group 14458",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14436",
    "data-name": "Group 14436",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20770",
    "data-name": "Path 20770",
    d: "M35.98,13.289a17.79,17.79,0,0,0-3.638-6.826,18.215,18.215,0,0,0-5.364-4.277A18.819,18.819,0,0,0,20.563.158,18.607,18.607,0,0,0,18.156,0,17.2,17.2,0,0,0,7.6,3.527,19.6,19.6,0,0,0,.66,14.011,17.419,17.419,0,0,0,1.9,26.605a13.329,13.329,0,0,0,1.123,1.8,9.683,9.683,0,0,0,6.848,4.052,9.927,9.927,0,0,0,1,.05,13.018,13.018,0,0,0,7.735-2.788,21.543,21.543,0,0,0,2.117,1.925A2.173,2.173,0,1,0,23.41,28.23a17.144,17.144,0,0,1-1.421-1.267,29.614,29.614,0,0,0,2.64-2.822,14.191,14.191,0,0,0,3.038-5.958,7.62,7.62,0,0,0-.067-3.466A7.007,7.007,0,0,0,26,11.73,6.2,6.2,0,0,0,23.6,10.1a6.293,6.293,0,0,0-2.233-.4,6.9,6.9,0,0,0-.847.053,9.3,9.3,0,0,0-5.05,2.414,8.831,8.831,0,0,0-2.82,4.9,9.178,9.178,0,0,0,.877,5.561,22.783,22.783,0,0,0,2.344,3.8,9.38,9.38,0,0,1-5,1.737,5.2,5.2,0,0,1-4.366-2.356,9.23,9.23,0,0,1-.759-1.214C2.783,18.917,4.756,11.18,10.238,6.979a12.993,12.993,0,0,1,7.99-2.65A14.185,14.185,0,0,1,29.035,9.287a13.687,13.687,0,0,1,3.138,10.845,14.2,14.2,0,0,1-4.54,8.7,2.175,2.175,0,1,0,2.918,3.226A18.7,18.7,0,0,0,35.98,13.288ZM19.2,23.6c-1.283-1.789-2.6-3.85-2.263-5.784a5.152,5.152,0,0,1,4.121-3.76,2.612,2.612,0,0,1,.311-.019,1.861,1.861,0,0,1,1.428.624,2.976,2.976,0,0,1,.618,2.605c-.537,2.512-2.517,4.7-4.214,6.335Z",
    transform: "translate(-0.022 0.003)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2",
    transform: "translate(51.268 8.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20783",
    "data-name": "Path 20783",
    d: "M415.346,160.37v5.451h-1.1V163.5h-2.332v2.319h-1.1V160.37h1.1v2.241h2.332V160.37Z",
    transform: "translate(-354.472 -138.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20784",
    "data-name": "Path 20784",
    d: "M465.583,161.209v1.372h1.834v.865h-1.834v1.446h2.068v.89H464.49V160.32h3.161v.889Z",
    transform: "translate(-400.781 -138.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20785",
    "data-name": "Path 20785",
    d: "M508.807,164.738h-2.17l-.359,1.04H505.13l1.96-5.458h1.273l1.961,5.458h-1.155Zm-.3-.874-.793-2.28-.789,2.28Z",
    transform: "translate(-435.847 -138.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20786",
    "data-name": "Path 20786",
    d: "M562.233,164.954h1.8v.867H561.14V160.37h1.1Z",
    transform: "translate(-484.175 -138.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20787",
    "data-name": "Path 20787",
    d: "M601.994,160.37v.882h-1.453v4.569h-1.1v-4.569H598v-.882Z",
    transform: "translate(-515.979 -138.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20788",
    "data-name": "Path 20788",
    d: "M650.216,160.37v5.451h-1.1V163.5h-2.332v2.319h-1.1V160.37h1.1v2.241h2.332V160.37Z",
    transform: "translate(-557.128 -138.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20789",
    "data-name": "Path 20789",
    d: "M7.012,37.518C3.528,37.518,0,35.186,0,30.714s3.528-6.8,7.012-6.8S14,26.242,14,30.714A6.679,6.679,0,0,1,7.012,37.518Zm0-10.081a3.084,3.084,0,0,0-3.093,3.278,3.086,3.086,0,1,0,6.161,0A3.071,3.071,0,0,0,7.012,27.436Z",
    transform: "translate(0 -20.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20790",
    "data-name": "Path 20790",
    d: "M124.756,43.812c-3.044,0-6.126-1.894-6.126-5.514V31.346a.346.346,0,0,1,.344-.346h3.017a.232.232,0,0,1,.23.229l.025,7.069a2.48,2.48,0,0,0,.71,1.783,2.515,2.515,0,0,0,1.793.7h.151a2.487,2.487,0,0,0,2.332-2.515V31.584A.584.584,0,0,1,127.82,31h2.461a.579.579,0,0,1,.579.577V38.3C130.859,41.918,127.789,43.812,124.756,43.812Z",
    transform: "translate(-102.359 -26.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20791",
    "data-name": "Path 20791",
    d: "M300.768,39.733a.56.56,0,0,1-.558-.56V27.343c0-4.456,3.528-6.793,7.012-6.793s6.987,2.332,6.987,6.8a6.68,6.68,0,0,1-6.987,6.8,7.73,7.73,0,0,1-2.753-.514l-.281-.11-.079.274.018,5.451a.48.48,0,0,1-.137.337.471.471,0,0,1-.336.137Zm6.453-15.657a3.08,3.08,0,0,0-3.093,3.277,3.086,3.086,0,1,0,6.161,0A3.073,3.073,0,0,0,307.221,24.076Z",
    transform: "translate(-259.033 -17.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20792",
    "data-name": "Path 20792",
    d: "M423.072,32.528c-3.484,0-7.012-2.332-7.012-6.8s3.528-6.8,7.012-6.8,6.987,2.332,6.987,6.8A6.68,6.68,0,0,1,423.072,32.528Zm0-10.081a3.081,3.081,0,0,0-3.093,3.278,3.086,3.086,0,1,0,6.161,0,3.071,3.071,0,0,0-3.068-3.278Z",
    transform: "translate(-358.994 -16.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20793",
    "data-name": "Path 20793",
    d: "M538.015,32.2c-2.648,0-4.425-1.115-5-3.141a.441.441,0,0,1,.04-.337.423.423,0,0,1,.258-.2l2.469-.672a.413.413,0,0,1,.11-.014.377.377,0,0,1,.344.2,1.762,1.762,0,0,0,1.7,1.07c.812,0,1.358-.429,1.358-1.07,0-.348-.174-.823-1.012-1.063l-1.975-.73c-2.02-.7-3.086-2.03-3.086-3.84,0-2.7,2.553-3.93,4.925-3.93a4.668,4.668,0,0,1,4.652,2.923.469.469,0,0,1-.029.388.489.489,0,0,1-.311.251l-2.242.549a.443.443,0,0,1-.112.014.549.549,0,0,1-.465-.3,1.439,1.439,0,0,0-1.3-.782,1.027,1.027,0,0,0-1.148.96c0,.361.193.842,1.121,1.1l1.842.675c1.458.466,3.189,1.5,3.189,3.786C543.333,30.563,541.245,32.2,538.015,32.2Z",
    transform: "translate(-459.891 -15.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20794",
    "data-name": "Path 20794",
    d: "M234.007,17.947c-4.84-.373-7.119-4.377-7.187-7.939V.573A.575.575,0,0,1,227.393,0h3.063a.48.48,0,0,1,.479.479v3h2.539a.343.343,0,0,1,.343.343V6.083a.549.549,0,0,1-.549.549h-2.332v3.4h.051a3.462,3.462,0,0,0,3.07,3.282.562.562,0,0,1,.486.549v3.616a.465.465,0,0,1-.137.336.488.488,0,0,1-.346.137Z",
    transform: "translate(-195.71 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20795",
    "data-name": "Path 20795",
    d: "M629.684,17.951c-4.872-.35-7.158-3.4-7.234-6.979V9.811h0V.311a.311.311,0,0,1,.3-.311h3.266a.539.539,0,0,1,.538.538V3.482h2.58a.3.3,0,0,1,.3.3v2.41a.436.436,0,0,1-.436.435h-2.445v3.4l.051.96c.093,1.749,1.394,2.13,3.225,2.347a.38.38,0,0,1,.33.384v3.808a.411.411,0,0,1-.137.3.454.454,0,0,1-.315.125Z",
    transform: "translate(-537.075 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.db42799fb82175e7cbd1c3cfca5f20ba.svg";
export { ForwardRef as ReactComponent };